import React, { useState, useEffect } from "react";
import { startAuthentication } from "@simplewebauthn/browser";

import { Link, useHistory } from "react-router-dom";
import "../../App.css";
import "./Login.css";
import axios from "axios";
import Cookies from "js-cookie";
import { sha256 } from "js-sha256";
import eyeShowPassword from "../../images/eyeShowPassword.png";
import eyeHidePassword from "../../images/eyeHidePassword.png";

const MIN_TIME_BETWEEN_OTP_RESENDS = 60 * 1000; // 1 minute
const MAX_OTP_SENDS_BEFORE_COOLDOWN = 3;

const LogIn = () => {
  const history = useHistory();

  const [loginMode, setLoginMode] = useState("password"); // password / emailCode
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [emailCode, setEmailCode] = useState("");
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [codeSentTimestamp, setCodeSentTimestamp] = useState(null);
  const [otpResendTimeLeft, setOtpResendTimeLeft] = useState(0);
  const [otpAmountSent, setOtpAmountSent] = useState(0);
  const [showDoubleistInfo, setShowDoubleistInfo] = useState(false);

  const [passwordInputType, setPasswordInputType] = useState("password");
  const [isErrorMessageDisplayed, setIsErrorMessageDisplayed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const israelPhoneValidatorRegex =
    /^\+?(972|0)(\-)?0?(([23489]{1}\d{7})|[5]{1}\d{8})$/i;

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  useEffect(() => {
    if (Cookies.get("userId")) {
      const userType = Cookies.get("userType");
      if (userType === "2") {
        history.push("/helperhome");
      } else {
        history.push("/questionnaires");
      }
    }
  }, [history]);

  const alertUser = (message) => {
    setIsErrorMessageDisplayed(true);
    setErrorMessage(message);
  };

  const clearError = () => {
    setIsErrorMessageDisplayed(false);
    setErrorMessage("");
  };

  const phoneValidator = (phoneNumber) => {
    return israelPhoneValidatorRegex.exec(phoneNumber) !== null;
  };

  const signUpClicked = () => {
    history.push("/signup");
  };

  const navigateAfterLogin = () => {
    console.log("navigate after login");
    const userType = Cookies.get("userType");

    if (userType === "2") {
      history.push("/helperhome");
    } else {
      history.push("/questionnaires");
    }
  };

  const logInClicked = async () => {
    clearError();

    if (!phoneValidator(phone)) {
      alertUser("מספר הטלפון לא תקין, יש להכניס מספר טלפון ישראלי");
      return;
    }

    if (!password) {
      alertUser("על מנת להתחבר יש להכניס סיסמה");
      return;
    }

    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/PlogIn",
        {
          phone,
          password: sha256(password),
        },
        config,
      );

      if (Cookies.get("userId") > "0" && response.status === 200) {
        navigateAfterLogin();
      } else {
        alertUser(
          "הסיסמה שגויה. לחצו על 👁 כדי לראות מה הקלדתם, ובדקו שלא התבלבלתם בין אותיות גדולות לקטנות.",
        );
      }
    } catch (error) {
      alertUser(
        "הסיסמה שגויה. לחצו על 👁 כדי לראות מה הקלדתם, ובדקו שלא התבלבלתם בין אותיות גדולות לקטנות.",
      );
    }
  };

  const loginWithPasskey = async () => {
    try {
      const optionsResponse = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/passkey/login/options",
        {},
        config,
      );

      const { options, loginFlowId } = optionsResponse.data;

      console.log("login options", options);
      console.log("loginFlowId", loginFlowId);

      //  ask the browser to sign challange
      const authenticationResponse = await startAuthentication({
        optionsJSON: options,
      });

      console.log("authentication response", authenticationResponse);

      const verifyResponse = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/passkey/login/verify",
        {
          loginFlowId,
          authenticationResponse,
        },
        config,
      );

      console.log("login verify response", verifyResponse.data);

      if (verifyResponse.data.verified) {
        console.log("Passkey login successful");

        // todo: login

        navigateAfterLogin();
      } else {
        // we should never get here as not verified should throw an error
        alertUser(
          "אירעה שגיאה בכניסה עם passkey. נא לנסות שוב בעוד רגע או להתחבר עם סיסמה או קוד למייל",
        );
      }
    } catch (error) {
      console.log("error", error);
      // error - probebly not have passkey
      alertUser("");

      // if 404 alert no passkey please login and add passkey to account
      if (error.response && error.response.status === 404) {
        alertUser(
          "עליך להתחבר לאתר בכניסה רגילה (סיסמה או קוד למייל) ולאחר מכן ניתן להגדיר כניסה באמצעות זיהוי ביומטרי",
        );
      }

      // if 400 error while varifying passkey please try again later
      if (error.response && error.response.status === 400) {
        alertUser(
          "אירעה שגיאה בכניסה עם זיהוי ביומטרי, נא להיכנס בכניסה רגילה",
        );
      }

      // if 500 error while varifying passkey please try again later
      if (error.response && error.response.status === 500) {
        alertUser(
          "אירעה שגיאה בכניסה עם זיהוי ביומטרי, נא להיכנס בכניסה רגילה",
        );
      }
    }
  };

  const sendCodeToEmail = async () => {
    clearError();

    if (!email) {
      alertUser("יש להכניס כתובת מייל");
      return;
    }

    const now = Date.now();
    if (
      codeSentTimestamp &&
      now - codeSentTimestamp < MIN_TIME_BETWEEN_OTP_RESENDS
    ) {
      // The user is not suppost to see this, as the UI should prevent it.
      alertUser("הקוד נשלח כבר לפני רגע. אנא המתן לפני שליחת קוד נוסף");
      return;
    }

    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/otp/send",
        {
          email,
        },
        config,
      );

      if (response.status === 200) {
        setIsCodeSent(true);
        setOtpAmountSent((otpAmountSent) => otpAmountSent + 1);
        setCodeSentTimestamp(Date.now());
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        alertUser("המייל לא נמצא במערכת. נא לנסות מייל אחר או להירשם לאתר");
      } else if (error.response && error.response.status === 400) {
        alertUser("נשלחו יותר מדי קודים. נא לנסות שוב בעוד כמה דקות");
      } else {
        alertUser("לא הצלחנו לשלוח קוד למייל. נא לנסות שוב בעוד רגע");
      }
    }
  };

  const loginWithEmailCode = async () => {
    clearError();

    if (!emailCode) {
      alertUser("יש להכניס את הקוד שנשלח למייל");
      return;
    }

    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/otp/verify",
        {
          email,
          otp: emailCode,
        },
        config,
      );

      if (Cookies.get("userId") > "0" && response.status === 200) {
        localStorage.setItem("loginByOtp", "1");
        navigateAfterLogin();
      } else {
        alertUser("הקוד שגוי או שפג תוקף");
      }
    } catch (error) {
      alertUser("הקוד שגוי או שפג תוקף");
    }
  };

  useEffect(() => {
    const updateFunction = () => {
      if (codeSentTimestamp) {
        const timeLeft = Math.max(
          0,
          MIN_TIME_BETWEEN_OTP_RESENDS - (Date.now() - codeSentTimestamp),
        );
        setOtpResendTimeLeft(timeLeft);
      }
    };
    const interval = setInterval(updateFunction, 1000);

    updateFunction();

    return () => clearInterval(interval);
  }, [codeSentTimestamp]);

  return (
    <div className="login-form">
      <div className="hp-logo" />

      <form className="login-form1">
        <br />
        <div className="doubleist-mini-box">
          <span className="doubleist-mini-title">דאבליסטים?</span>
          <span className="doubleist-mini-text">
            נכנסים כאן גם מלווים ושדכנים.
          </span>
          <span
            className="doubleist-mini-link"
            onClick={() => setShowDoubleistInfo(!showDoubleistInfo)}
          >
            מה זה?
          </span>

          {showDoubleistInfo && (
            <div className="doubleist-mini-more">
              דאבליסט הוא חבר/ה מלווה, בן משפחה או שדכן/ית שעוזר/ת למועמדים
              למצוא התאמות ולעקוב יחד אחרי ההצעות. לאחר הכניסה נזהה אותך ונעביר
              אותך למקום המתאים.
            </div>
          )}
        </div>

        <div className="login-tabs">
          <div
            className={`login-tab ${loginMode === "password" ? "active" : ""}`}
            onClick={() => {
              clearError();
              setLoginMode("password");
            }}
          >
            עם סיסמה
          </div>

          <div
            className={`login-tab ${loginMode === "emailCode" ? "active" : ""}`}
            onClick={() => {
              clearError();
              setLoginMode("emailCode");
            }}
          >
            קוד למייל
          </div>
        </div>

        {loginMode === "password" ? (
          <>
            <input
              type="number"
              id="tel"
              placeholder="טלפון"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />

            <div className="password-input-container">
              <span
                className="password-input-span"
                onClick={() =>
                  setPasswordInputType(
                    passwordInputType === "password" ? "text" : "password",
                  )
                }
              >
                {passwordInputType === "text" ? (
                  <img className="eye-image-in-span" src={eyeHidePassword} />
                ) : (
                  <img className="eye-image-in-span" src={eyeShowPassword} />
                )}
              </span>

              <input
                type={passwordInputType}
                id="pwd"
                placeholder="סיסמה"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="button-text-center" onClick={logInClicked}>
              כניסה
            </div>
          </>
        ) : (
          <>
            <input
              type="email"
              placeholder='דוא"ל'
              value={email}
              autoComplete="off"
              onChange={(e) => setEmail(e.target.value)}
            />

            <div className="email-code-note">
              נשלח לך קוד חד פעמי. הקוד תקף ל־10 דקות.
            </div>

            <div
              className="button whiteBackNBorder"
              onClick={sendCodeToEmail}
              style={{
                margin: "10px auto 16px",
                width: "70%",
                maxWidth: "300px",
                minHeight: "42px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                lineHeight: "1.2",
                padding: "0 18px",
                boxSizing: "border-box",
              }}
            >
              {isCodeSent ? "שלחו לי קוד נוסף" : "שלחו לי קוד למייל"}
            </div>

            <input
              type="number"
              placeholder="הקוד שקיבלת במייל"
              value={emailCode}
              onChange={(e) => setEmailCode(e.target.value)}
            />

            <div className="button-text-center" onClick={loginWithEmailCode}>
              כניסה עם הקוד
            </div>
            {otpAmountSent >= MAX_OTP_SENDS_BEFORE_COOLDOWN ? (
              <div className="login-switch-hint">
                שלחת מספר בקשות קוד בזמן קצר 😊 ניתן לבקש קוד נוסף בעוד 10 דקות.
                ולבינתיים מומלץ לבדוק בתיקיית הספאם/עדכונים
              </div>
            ) : otpResendTimeLeft > 0 ? (
              <div className="login-switch-hint">
                ניתן לשלוח קוד נוסף בעוד {Math.ceil(otpResendTimeLeft / 1000)}{" "}
                שניות
              </div>
            ) : (
              <div className="login-switch-hint" onClick={sendCodeToEmail}>
                לא קיבלת? שלחו לי שוב
              </div>
            )}
          </>
        )}

        {isErrorMessageDisplayed && (
          <div className="error-message">
            <h5>{errorMessage}</h5>
          </div>
        )}
        <br />

        <div className="passkey-login-btn" onClick={loginWithPasskey}>
          🔐 כניסה מהירה מהטלפון הזה
        </div>
        {loginMode === "emailCode" && (
          <a
            className="login-whatsapp-help"
            href="https://wa.me/972549624084?text=שלום, אני לא מצליח/ה להיכנס לאתר דאבל"
            target="_blank"
            rel="noreferrer"
          >
            יש בעיה בכניסה? כתבו לנו בווטסאפ
          </a>
        )}

        <Link to="/" className="back-link-minimal">
          חזרה
        </Link>

        <div className="signup-line-clean">
          אין לך חשבון? <span onClick={signUpClicked}>להרשמה</span>
        </div>

        <div className="cookies-text small">
          האתר משתמש ב-Cookies. המשך גלישה מהווה הסכמה.
        </div>
      </form>
    </div>
  );
};

export default LogIn;
